import { useHistory } from 'react-router-dom'
import { Button } from 'react-bootstrap'

import GoBackHeader from 'components/organisms/GoBackHeader'

import {
  LoginForgotNoAccountContainer,
  LoginForgotNoAccountTitle,
  LoginForgotNoAccountButton
} from './styles'

function LoginForgotNoAccount(): JSX.Element {
  const history = useHistory()

  return (
    <>
      <GoBackHeader text='Forgot Login Credentials' />
      <LoginForgotNoAccountContainer>
        <LoginForgotNoAccountTitle data-testid='forgot-no-account-title'>
          We could not find your account in our system
        </LoginForgotNoAccountTitle>
        <p data-testid='forgot-no-acccount-message'>
          We could not find an account that matches your answers in our system.
          Please try again or contact your attorney for additional help.
        </p>

        <LoginForgotNoAccountButton>
          <Button
            onClick={() => {
              history.push('/login')
            }}
            data-testid='forgot-no-account-continue-button'
          >
            Continue
          </Button>
        </LoginForgotNoAccountButton>
      </LoginForgotNoAccountContainer>
    </>
  )
}

export default LoginForgotNoAccount
